import { useState, useEffect } from "react";
import { b as isFalsy } from "./index-CzdAPYVv.js";
import { a as getDataLayer } from "./OffersContext-CKQZ2fOu.js";
import { b as MARKETING_CLICK_ID_MAX_RETRY, c as MARKETING_CLICK_ID_TIMEOUT } from "./index-Dm8TmbQW.js";
const formatMarketingClickId = (marketingClickId) => typeof marketingClickId === "string" ? marketingClickId : null;
const useMarketingClickId = ({ defaultMarketingClickId }) => {
  const [marketingClickId, setMarketingClickId] = useState(null);
  const [marketingClickError, setMarketingClickError] = useState(null);
  const [marketingClickSuccess, setMarketingClickSuccess] = useState(false);
  const dataLayer = getDataLayer();
  const isDataFunctionAvailable = () => dataLayer && typeof dataLayer.getData === "function";
  useEffect(() => {
    let mcid = null;
    if (defaultMarketingClickId !== void 0) {
      mcid = isFalsy(defaultMarketingClickId) ? null : formatMarketingClickId(defaultMarketingClickId);
      setMarketingClickId(mcid);
      setMarketingClickSuccess(mcid !== null);
      return;
    }
    if (!isDataFunctionAvailable()) {
      console.warn("dataLayer or getData is not available. Skipping marketingClickId retrieval.");
      setMarketingClickError("dataLayer.getData() is unavailable.");
      return;
    }
    let retryCount = 0;
    const maxRetries = MARKETING_CLICK_ID_MAX_RETRY;
    const getMarketingClickId = () => {
      var _a;
      try {
        mcid = ((_a = dataLayer.getData()) == null ? void 0 : _a.marketingClickId) ?? null;
        if (mcid !== null) {
          setMarketingClickId(mcid);
          setMarketingClickSuccess(true);
          return;
        }
        if (retryCount < maxRetries) {
          retryCount++;
          setTimeout(getMarketingClickId, MARKETING_CLICK_ID_TIMEOUT);
          return;
        }
        console.error("Max retries reached. marketingClickId remains null.");
        setMarketingClickError("marketingClickId could not be retrieved.");
      } catch (err) {
        setMarketingClickError(err.message);
        console.error("Error getting marketingClickId:", err);
      }
    };
    getMarketingClickId();
  }, [defaultMarketingClickId]);
  return { marketingClickSuccess, marketingClickError, marketingClickId };
};
export {
  useMarketingClickId as u
};
//# sourceMappingURL=useMarketingClickId-Bx_4whWU.js.map
